class ScrollManager {
    constructor() {
        this.instances = new Map();
        this.init();
    }

    init() {
        // Находим все попапы на странице
        const popups = document.querySelectorAll('.pc-configurator-popup-content');
        
        popups.forEach(popup => {
            const configuratorId = popup.closest('.pc-configurator-popup').dataset.configuratorId;
            
            // Инициализируем Simplebar для каждого попапа
            const instance = new SimpleBar(popup, {
                autoHide: false,
                clickOnTrack: true,
                scrollbarMinSize: 50
            });

            // Сохраняем экземпляр в Map с id конфигуратора как ключом
            this.instances.set(configuratorId, instance);
        });
    }

    // Метод для получения экземпляра Simplebar по id конфигуратора
    getInstance(configuratorId) {
        return this.instances.get(configuratorId);
    }

    // Метод для обновления скроллбара (может быть полезен при динамическом изменении контента)
    recalculate(configuratorId) {
        const instance = this.instances.get(configuratorId);
        if (instance) {
            instance.recalculate();
        }
    }

    // Метод для уничтожения экземпляра при необходимости
    destroy(configuratorId) {
        const instance = this.instances.get(configuratorId);
        if (instance) {
            instance.unMount();
            this.instances.delete(configuratorId);
        }
    }
} 